import React, { useEffect, useState, useContext } from "react";
import { connect } from "react-redux";
import "./index.css";
import ContextForm from "../../ReportForm/contextForm";

const CustomInput = (props) => {
  const { label, isRequired, onChange, type, className = '' } = props;
  const context = useContext(ContextForm);
  const { errorFieldsPublicForm, errorFieldsProfessionalForm } = context;

  const [errorField, setErrorField] = useState(false);
  const [text, setText] = useState("");

  const handleChange = (event) => {
    if (errorField) {
      setErrorField(false);
    }
    setText(event.target.value);
    onChange(event.target.value);
  };

  useEffect(() => {
    if (
      text === "" &&
      isRequired &&
      (errorFieldsPublicForm === true || errorFieldsProfessionalForm === true)
    ) {
      setErrorField(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorFieldsPublicForm, errorFieldsProfessionalForm]);


  return (
    <div className={`element ${className}`}>
      <label className="label">
        {label} {isRequired && <span>*</span>}
      </label>
      <input
        className={`custom-input height-element ${errorField ? "error_form" : ""
          }`}
        value={text}
        onChange={handleChange}
        type={type ? type : "text"}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(CustomInput);
